import { useAuth0 } from "@auth0/auth0-react";
import Search from "../Lookup/Search";
import LoginPrompt from "../Auth/LoginPrompt";
import { Col, Container, Row } from "react-bootstrap";

export default function Lookup() {
  const { isAuthenticated } = useAuth0();
  return (
    <div className="lookup">
      <h1>Property Search</h1>
      <Container>
        <Row className="justify-content-center">
          <Col lg={6}>
            <div className="lookup-description">
              Conduct a preliminary search on any property within NYC five
              boroughs based on Department of Finance, Buildings, and Housing,
              Preservation, & Development.
            </div>
          </Col>
        </Row>
      </Container>
      {isAuthenticated ? (
        <Search />
      ) : (
        <LoginPrompt message="Sign up now for a free trial! Already have an account? Sign-In!" />
      )}
    </div>
  );
}
